<template>
	<div class="Checkbox">
		<label class="container littleAndBold"><input type="checkbox" v-model="value"><span class="checkmark"></span><span v-html="labelHTML"></span></label>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	name: 'Checkbox',
	props: {
		dataKey: String,
		labelHTML: String,
	},
	data() {
		return {
			value: this.$store.state[this.dataKey],
		}
	},
	watch: {
		value(newValue) {
			this.setPartnerDataValue({ key: this.dataKey, value: newValue })
		},
	},
	computed: {},
	methods: {
		...mapActions(['setPartnerDataValue']),
	},
	components: {},
}
</script>

<style lang="stylus" scoped>
/* The container */
.container {
	display: block;
	position: relative;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 16px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	display: inline-block;
	width: 16px;
	height: 16px;
	outline: none;
	border: 2px solid gray;
	border-radius: 2px;
	position: relative;
	top: 4px;
	margin-right: 10px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
	background-color: #f9f9f9;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
	border-color: #1bcbac;
	background: #1bcbac;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: '';
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
	display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
	left: 4px;
    top: 0px;
	width: 5px;
	height: 10px;
	border: solid white;
	border-width: 0 3px 3px 0;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
}
</style>
